import { Injectable, Inject, forwardRef } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { IApiresponse } from "../../_models/common/request-response/apiresponse";
import { IApiRequest } from "../../_models/common/request-response/api-request";
import { setHeader } from "../../_helpers/setRequestHeader";
import { ClaimsHeaderService } from "../../shared/claimsHeader/claims-header.service";
import {
    ICompanyListRequest,
    ICompanyListResponse,
    ICompanyResponse,
    ICompanyEmployeeListRequest,
    ICompanyEmployeeListResponse,
    IActiveCompanyForSelectionResponse,
    IEmployeeListForCompanyAssignmentRequest,
    IEmployeeListForCompanyAssignmentResponse,
    IBulkCompanyAssignToEmployeeRequest,
    IAssignAccountingCodeToCompanyGridRequest,
    IAssignAccountingCodeToCompanyGridResponse,
    IExpenseCategoriesForCompanyRequest,
    IExpenseCategoriesForCompanyResponse,
    IUpdateCompanyCategoryAccountingCodeRuleRequest,
    IOrgCompanyApproverRuleResponse,
    ISaveOrgCompanyApproverRuleRequest,
    ISetupCompanyRulesGridResponse,
    ISetupCompanyRulesGridRequest,
    ICompanyFinanceManagersRulesDetailsRequest,
    ICompanyFinanceManagersRulesDetailsResponse,
    ISaveCompanyFMAssignmentRequest,
    ICompanyListAssignedToFMRequest,
    IFinanceManagerIdResponse,
    IPendingExpensesCountOfCompanyRequest,
    CompanyRequest,
    AssignedFinanceManagersToCompanyRequest,
    IAssignedFinanceManagersToCompanyResponse,
    GetCompaniesAssignedToFinanceManagerRequest,
    ICompanyDetailsForUnsubscribe,
    IPendingCompanyExpenseRequest,
    IPendingExpenseResponse,
    IBulkSendReminderToApproverRequest,
    IUserPendingExpenseRequest,
    DetailsForCompanyCardAccessGrantRequest,
    CompanyCardAccessGrantDetailResponse,
    CompanyCardAccessGrantClaimantRequest,
    CompanyCardAccessGrantClaimant,
    CompanyCardAccessGrantDetail,
    SaveCompanyCardAccessGrantsMappingRequest,
    SaveCompanyCardAccessGrantsRequest
} from "../../_models/multiple-companies/multiple-companies";
import { BackgroundTaskKeys, BackgroundTaskNotificationBody, BackgroundTaskNotificationHeaders, BackgroundTaskTopics } from 'src/app/common/commonvariables';
import { BackgroundTask } from 'src/app/_models/common/background-task';
import { NotificationService } from 'src/app/_services/common/notification.service';
import { FunctionPackageEnum, FunctionPrivilege, BillingMethod } from 'src/app/_models';


@Injectable({
    providedIn: "root",
})
export class MultipleCompaniesService {
    httpHeaders: HttpHeaders;
    constructor(
        private http: HttpClient,
        private claimsHeaderService: ClaimsHeaderService,
        private notificationService: NotificationService
    ) { }

    GetCompanyByOrgId(
        requestInfo: IApiRequest<ICompanyListRequest>
    ): Observable<IApiresponse<ICompanyListResponse>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<ICompanyListResponse>>(
            `${environment.billingApiUrl}GetCompanyByOrgId`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    GetCompanyById(companyId: number): Observable<IApiresponse<ICompanyResponse>> {
        let params = new HttpParams();
        params = params.append("companyId", companyId.toString());
        return this.http.get<IApiresponse<ICompanyResponse>>(
            `${environment.billingApiUrl}GetCompanyById`,
            {
                params: params,
                headers: this.claimsHeaderService.createLoginAuthorizationHeader()
            }
        );
    }

    AddCompany(
        requestInfo: IApiRequest<CompanyRequest>
    ): Observable<IApiresponse<any>> {

        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<any>>(
            `${environment.billingApiUrl}AddCompany`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    UpdateCompany(
        requestInfo: IApiRequest<CompanyRequest>
    ): Observable<IApiresponse<any>> {

        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<any>>(
            `${environment.billingApiUrl}UpdateCompany`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    BulkCompanyAssignToEmployee(
        requestInfo: IApiRequest<IBulkCompanyAssignToEmployeeRequest>
    ): Observable<IApiresponse<any>> {

        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<any>>(
            `${environment.billingApiUrl}BulkCompanyAssignToEmployee`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    GetCompanyEmployeeList(
        requestInfo: IApiRequest<ICompanyEmployeeListRequest>
    ): Observable<IApiresponse<ICompanyEmployeeListResponse>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<ICompanyEmployeeListResponse>>(
            `${environment.billingApiUrl}GetCompanyEmployeeList`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    GetActiveCompanyForSelectionByOrgId(organisationId: number): Observable<IApiresponse<IActiveCompanyForSelectionResponse[]>> {
        let params = new HttpParams();
        params = params.append("organisationId", organisationId.toString());
        return this.http.get<IApiresponse<IActiveCompanyForSelectionResponse[]>>(
            `${environment.billingApiUrl}GetActiveCompanyForSelectionByOrgId`,
            {
                params: params,
                headers: this.claimsHeaderService.createLoginAuthorizationHeader()
            }
        );
    }

    GetEmployeeListForCompanyAssignment(
        requestInfo: IApiRequest<IEmployeeListForCompanyAssignmentRequest>
    ): Observable<IApiresponse<IEmployeeListForCompanyAssignmentResponse>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<IEmployeeListForCompanyAssignmentResponse>>(
            `${environment.billingApiUrl}GetEmployeeListForCompanyAssignment`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }


    GetAssignAccountingCodeToCompanyGrid(
        requestInfo: IApiRequest<IAssignAccountingCodeToCompanyGridRequest>
    ): Observable<IApiresponse<IAssignAccountingCodeToCompanyGridResponse>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<IAssignAccountingCodeToCompanyGridResponse>>(
            `${environment.billingApiUrl}GetAssignAccountingCodeToCompanyGrid`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }



    GetExpenseCategoriesForCompany(
        requestInfo: IApiRequest<IExpenseCategoriesForCompanyRequest>
    ): Observable<IApiresponse<IExpenseCategoriesForCompanyResponse[]>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<IExpenseCategoriesForCompanyResponse[]>>(
            `${environment.billingApiUrl}GetExpenseCategoriesForCompany`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }




    UpdateCompanyCategoryAccountingCodeRule(
        requestInfo: IApiRequest<IUpdateCompanyCategoryAccountingCodeRuleRequest>
    ): Observable<IApiresponse<any>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<any>>(
            `${environment.billingApiUrl}UpdateCompanyCategoryAccountingCodeRule`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }



    CheckOrgActiveCategoryWithoutAccountingCode(organisationId: number): Observable<IApiresponse<boolean>> {
        let params = new HttpParams();
        params = params.append("organisationId", organisationId.toString());
        return this.http.get<IApiresponse<boolean>>(
            `${environment.billingApiUrl}CheckOrgActiveCategoryWithoutAccountingCode`,
            {
                params: params,
                headers: this.claimsHeaderService.createLoginAuthorizationHeader()
            }
        );
    }

    GetOrgCompanyApproverRule(organisationId: number): Observable<IApiresponse<IOrgCompanyApproverRuleResponse>> {
        let params = new HttpParams();
        params = params.append("organisationId", organisationId.toString());
        return this.http.get<IApiresponse<IOrgCompanyApproverRuleResponse>>(
            `${environment.billingApiUrl}GetOrgCompanyApproverRule`,
            {
                params: params,
                headers: this.claimsHeaderService.createLoginAuthorizationHeader()
            }
        );
    }

    SaveOrgCompanyApproverRule(
        requestInfo: IApiRequest<ISaveOrgCompanyApproverRuleRequest>
    ): Observable<IApiresponse<any>> {

        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<any>>(
            `${environment.billingApiUrl}SaveOrgCompanyApproverRule`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }


    GetSetupCompanyRulesGrid(
        requestInfo: IApiRequest<ISetupCompanyRulesGridRequest>
    ): Observable<IApiresponse<ISetupCompanyRulesGridResponse>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<ISetupCompanyRulesGridResponse>>(
            `${environment.billingApiUrl}GetSetupCompanyRulesGrid`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }


    GetCompanyFinanceManagersRulesDetails(
        requestInfo: IApiRequest<ICompanyFinanceManagersRulesDetailsRequest>
    ): Observable<IApiresponse<ICompanyFinanceManagersRulesDetailsResponse>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<ICompanyFinanceManagersRulesDetailsResponse>>(
            `${environment.billingApiUrl}GetCompanyFinanceManagersRulesDetails`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }


    SaveCompanyFMAssignment(
        requestInfo: IApiRequest<ISaveCompanyFMAssignmentRequest>
    ): Observable<IApiresponse<any>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<any>>(
            `${environment.billingApiUrl}SaveCompanyFMAssignment`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    GetCompanyListAssignedToFM(
        requestInfo: IApiRequest<ICompanyListAssignedToFMRequest>
    ): Observable<IApiresponse<ICompanyResponse[]>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<ICompanyResponse[]>>(
            `${environment.billingApiUrl}GetCompanyListAssignedToFM`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    GetAssignedFinanceManagerIdsToCompany(organisationId: number): Observable<IApiresponse<IFinanceManagerIdResponse[]>> {
        let params = new HttpParams();
        params = params.append("organisationId", organisationId.toString());
        return this.http.get<IApiresponse<IFinanceManagerIdResponse[]>>(
            `${environment.billingApiUrl}GetAssignedFinanceManagerIdsToCompany`,
            {
                params: params,
                headers: this.claimsHeaderService.createLoginAuthorizationHeader()
            }
        );
    }

    GetPendingExpensesCountOfCompany(
        requestInfo: IApiRequest<IPendingExpensesCountOfCompanyRequest>
    ): Observable<IApiresponse<number>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<number>>(
            `${environment.expenseApiUrl}GetPendingExpensesCountOfCompany`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    GetMasterCompanyEmployeeList(
        organisationId: number
    ): Observable<IApiresponse<ICompanyEmployeeListResponse>> {
        let params = new HttpParams();
        params = params.append("organisationId", organisationId.toString());
        return this.http.get<IApiresponse<ICompanyEmployeeListResponse>>(
            `${environment.billingApiUrl}GetMasterCompanyEmployeeList`,
            {
                params: params,
                headers: this.claimsHeaderService.createLoginAuthorizationHeader()
            }
        );
    }

    GetAssignedFinanceManagersToCompany(
        requestInfo: IApiRequest<AssignedFinanceManagersToCompanyRequest>
    ): Observable<IApiresponse<IAssignedFinanceManagersToCompanyResponse[]>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<IAssignedFinanceManagersToCompanyResponse[]>>(
            `${environment.billingApiUrl}GetAssignedFinanceManagersToCompany`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    GetCompanyWiseAssignmentForFinanceManager(organisationId: number): Observable<IApiresponse<ICompanyResponse[]>> {
        let params = new HttpParams();
        params = params.append("organisationId", organisationId.toString());
        return this.http.get<IApiresponse<ICompanyResponse[]>>(
            `${environment.billingApiUrl}GetCompanyWiseAssignmentForFinanceManager`,
            {
                params: params,
                headers: this.claimsHeaderService.createLoginAuthorizationHeader()
            }
        );
    }

    GetCompaniesAssignedToFinanceManager(
        requestInfo: IApiRequest<GetCompaniesAssignedToFinanceManagerRequest>
    ): Observable<IApiresponse<ICompanyResponse[]>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<ICompanyResponse[]>>(
            `${environment.billingApiUrl}GetCompaniesAssignedToFinanceManager`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    BulkCompanyAssignToEmployeeBackground(
        saveRequest: IApiRequest<IBulkCompanyAssignToEmployeeRequest>): Observable<any> {
        const notificationBody = BackgroundTaskNotificationBody.BulkCompanyAssignToEmployee;
        const route = "orgsetting/assignemployeestocompany";
        let jobInfo = new BackgroundTask(BackgroundTaskTopics.Billing, BackgroundTaskKeys.BulkCompanyAssignToEmployee,
          saveRequest, saveRequest.requestInfo.userOrgMappingIds.map(e => e.toString()), BackgroundTaskNotificationHeaders.BulkCompanyAssignToEmployee,
          notificationBody, route,
          FunctionPackageEnum.SetupMultipleCompanies, FunctionPrivilege.SetupMultipleCompanies, saveRequest.requestInfo.userName);
    
        return this.notificationService.submitBackgroundJob(jobInfo);
      }

      GetCompanyDetailsForUnsubscribe(organisationId: number): Observable<IApiresponse<ICompanyDetailsForUnsubscribe>> {
        let params = new HttpParams();
        params = params.append("organisationId", organisationId.toString());
        return this.http.get<IApiresponse<ICompanyDetailsForUnsubscribe>>(
            `${environment.billingApiUrl}GetCompanyDetailsForUnsubscribe`,
            {
                params: params,
                headers: this.claimsHeaderService.createLoginAuthorizationHeader()
            }
        );
    }

    GetPendingCompanyExpenseList(
        requestInfo: IApiRequest<IPendingCompanyExpenseRequest>
    ): Observable<IApiresponse<IPendingExpenseResponse[]>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<IPendingExpenseResponse[]>>(
            `${environment.expenseApiUrl}GetPendingCompanyExpenseList`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    BulkSendReminderToApprover(
        requestInfo: IApiRequest<IBulkSendReminderToApproverRequest>
    ): Observable<IApiresponse<any>> {

        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<any>>(
            `${environment.billingApiUrl}BulkSendReminderToApprover`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    GetUserPendingExpenseList(
        requestInfo: IApiRequest<IUserPendingExpenseRequest>
    ): Observable<IApiresponse<IPendingExpenseResponse[]>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<IPendingExpenseResponse[]>>(
            `${environment.expenseApiUrl}GetUserPendingExpenseList`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    GetCompanyCardAccessGrantDetailList(
        requestInfo: IApiRequest<DetailsForCompanyCardAccessGrantRequest>
    ): Observable<IApiresponse<CompanyCardAccessGrantDetailResponse>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<CompanyCardAccessGrantDetailResponse>>(
            `${environment.billingApiUrl}GetCompanyCardAccessGrantDetailList`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

      GetCompanyCardAccessGrantClaimantList(requestInfo: IApiRequest<CompanyCardAccessGrantClaimantRequest>): Observable<IApiresponse<CompanyCardAccessGrantClaimant[]>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<CompanyCardAccessGrantClaimant[]>>(
          `${environment.billingApiUrl}GetCompanyCardAccessGrantClaimantList`,
          body,
          { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
      }
    
      SaveCompanyCardAccessGrantsMapping(requestInfo: IApiRequest<SaveCompanyCardAccessGrantsMappingRequest>): Observable<IApiresponse<any>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<any>>(
          `${environment.billingApiUrl}SaveCompanyCardAccessGrantsMapping`,
          body,
          { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
      }
    
       SendCompanyCardAccessGrantRequest(requestInfo: IApiRequest<SaveCompanyCardAccessGrantsRequest>): Observable<IApiresponse<any>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<any>>(
          `${environment.billingApiUrl}SendCompanyCardAccessGrantRequest`,
          body,
          { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
      }

     GetCompanyCardAccessGrantRequestedList(requestInfo: IApiRequest<DetailsForCompanyCardAccessGrantRequest> ): Observable<IApiresponse<CompanyCardAccessGrantDetailResponse>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<CompanyCardAccessGrantDetailResponse>>(
            `${environment.billingApiUrl}GetCompanyCardAccessGrantRequestedList`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

     UpdateStatusCompanyCardAccessGrants(requestInfo: IApiRequest<SaveCompanyCardAccessGrantsRequest>): Observable<IApiresponse<any>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<any>>(
          `${environment.billingApiUrl}UpdateStatusCompanyCardAccessGrants`,
          body,
          { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
      }



    GetApiDeckSessionToken(accountingSystemId): Observable<any> {
        return this.http.get<any>(
            `${environment.exportApiUrl}GetApiDeckSessionToken/${accountingSystemId}`,
            {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader()
            }
        );
    }

    SaveApiDeckConnection(connection, accountingSystemId): Observable<any> {
        return this.http.post<any>(
            `${environment.exportApiUrl}SaveApiDeckConnection/${accountingSystemId}`,
            connection,
            {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader()
            }
        );
    }

}


